import { Affix, ActionIcon, Indicator, Stack, Tooltip } from '@mantine/core';
import { InlineIcon } from '@iconify/react';
import { Permission } from 'api/user';
import { can } from 'helpers/userUtils';
import { useMe } from 'store/userStore';
import { useAiCoachAssistantStore } from 'store/aiCoachAssistantStore';
import { useFabStyles } from './Fab.styles';
import { ASSISTANT_POPOVER_Z_INDEX, ASSISTANT_Z_INDEX } from './constants';

export const Fab = () => {
  const { classes, cx } = useFabStyles();
  const me = useMe();
  const open = useAiCoachAssistantStore((s) => s.open);
  const isOpen = useAiCoachAssistantStore((s) => s.isOpen);
  const unreadCount = useAiCoachAssistantStore((s) => s.unreadCount);

  const canChatWithMembers = can(
    me,
    Permission.COACHING_WRITE,
    Permission.THERAPY_ALL
  );

  if (isOpen) return null;

  return (
    <Affix position={{ bottom: 24, right: 24 }} zIndex={ASSISTANT_Z_INDEX}>
      <Stack gap="sm" align="center">
        <Tooltip
          label="Ask the AI assistant"
          position="left"
          zIndex={ASSISTANT_POPOVER_Z_INDEX}
          withArrow>
          <Indicator
            label={unreadCount > 0 ? unreadCount : undefined}
            size={22}
            color="red"
            disabled={unreadCount === 0}
            offset={4}>
            <ActionIcon
              className={cx(classes.fab, {
                [classes.pulsing]: unreadCount > 0,
              })}
              aria-label="Ask the AI assistant"
              onClick={() => open('ai')}>
              <InlineIcon icon="mdi:robot-happy" height={28} />
            </ActionIcon>
          </Indicator>
        </Tooltip>

        {canChatWithMembers && (
          <Tooltip
            label="Message a member"
            position="left"
            zIndex={ASSISTANT_POPOVER_Z_INDEX}
            withArrow>
            <ActionIcon
              className={cx(classes.fab, classes.fabMember)}
              aria-label="Message a member"
              onClick={() => open('member')}>
              <InlineIcon icon="mdi:account" height={28} />
            </ActionIcon>
          </Tooltip>
        )}
      </Stack>
    </Affix>
  );
};
